module.exports = __webpack_public_path__ + "static/media/visitors.2cd6dea1.png";